var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-dropdown" }, [
    _c(
      "label",
      { staticClass: "u-sr-only", attrs: { for: _vm.ariaSelectId } },
      [_vm._v("\n    " + _vm._s(_vm.description || _vm.placeholder) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "select",
      {
        staticClass: "c-dropdown__select",
        attrs: { name: _vm.ariaSelectId },
        domProps: { value: _vm.value },
        on: { change: _vm.handleChange, input: _vm.handleChange }
      },
      [
        _vm._l(_vm.computedOptions, function(item, index) {
          return [
            item.group
              ? _c(
                  "optgroup",
                  {
                    key: index + "-" + item.group,
                    staticClass: "c-dropdown__optgroup",
                    attrs: { label: item.group }
                  },
                  _vm._l(item.options, function(option) {
                    return _c(
                      "option",
                      _vm._b(
                        {
                          key: option.value,
                          staticClass: "c-dropdown__option",
                          style: option.style,
                          attrs: { disabled: option.disabled }
                        },
                        "option",
                        option,
                        false
                      ),
                      [
                        _vm._v(
                          "\n          " + _vm._s(option.label) + "\n        "
                        )
                      ]
                    )
                  }),
                  0
                )
              : _c(
                  "option",
                  _vm._b(
                    {
                      key: item.value,
                      staticClass: "c-dropdown__option",
                      style: item.style,
                      attrs: { disabled: item.disabled }
                    },
                    "option",
                    item,
                    false
                  ),
                  [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]
                )
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }